import React from 'react';
import './WhatsAppWidget.css';

const WhatsAppWidget = () => {
  return (
    <a
      href="https://wa.me/916369627698?text=Hello%20Trevox%20Technologies%20team%2C%20I%20would%20like%20to%20discuss%20a%20project%20consultation."
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp-widget"
      aria-label="Direct WhatsApp Consultation"
    >
      <div className="whatsapp-pulse"></div>
      <svg
        className="whatsapp-icon"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="currentColor"
      >
        <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.771-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.275.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824zm-3.423-14.416c-6.627 0-12 5.373-12 12 0 2.155.57 4.178 1.564 5.927l-1.564 5.72 5.861-1.537c1.705.932 3.666 1.469 5.751 1.469 6.627 0 12-5.373 12-12s-5.373-12-12-12z" />
      </svg>
      <span className="whatsapp-tooltip">Chat with Enterprise Advisor</span>
    </a>
  );
};

export default WhatsAppWidget;
